import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';

const SidebarLink = ({
  title, icon, newLink, inside, route, onClick, hasAccess
}) => (
  <NavLink
    to={route}
    onClick={onClick}
    activeClassName="sidebar__link-active"
    style={{display: hasAccess ? 'block' : 'none'}}
  >
    <li className="sidebar__link">
      {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}

      {inside ? 
        <p className="sidebar__link-title" style={{paddingLeft: '20px', paddingTop: '5px'}}>
          {title}
          {newLink ? <Badge className="sidebar__link-badge"><span>New</span></Badge> : ''}
        </p> : '' }

      {!inside ? 
        <p className="sidebar__link-title">
          {title}
          {newLink ? <Badge className="sidebar__link-badge"><span>New</span></Badge> : ''}
        </p> : '' }

    </li>
  </NavLink>
);

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  inside: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
  hasAccess: PropTypes.bool
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  inside: false,
  route: '/',
  onClick: () => {},
  hasAccess: false
};

export default SidebarLink;
